import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Calendar, Clock } from "lucide-react";
import Layout from "@/components/site/Layout";
import { Reveal } from "@/components/site/Reveal";
import SafeHtml from "@/components/site/SafeHtml";
import api from "@/lib/api";

export default function BlogDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/blog/${slug}`).then((r) => {
      setPost(r.data);
      document.title = (r.data.meta_title || r.data.title) + " | Labpronics Technologies";
    }).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound)
    return (
      <Layout>
        <div className="container-lp pt-40 pb-32 text-center">
          <h1 className="font-heading font-700 text-4xl text-lp-blue">Article Not Found</h1>
          <Link to="/insights" className="inline-block mt-6 text-lp-cyan font-600">← Back to Insights</Link>
        </div>
      </Layout>
    );

  if (!post) return <div className="min-h-screen bg-lp-grey" />;

  return (
    <Layout>
      <article className="pt-[74px]">
        <div className="bg-lp-grey border-b border-lp-border">
          <div className="container-lp py-14 max-w-3xl">
            <Link to="/insights" data-testid="blog-back" className="inline-flex items-center gap-2 text-lp-cyan font-600 text-sm mb-6"><ArrowLeft size={16} /> Insights</Link>
            <span className="eyebrow">{post.category}</span>
            <h1 className="font-heading font-700 text-lp-blue text-3xl md:text-5xl leading-tight tracking-tight mt-4">{post.title}</h1>
            <div className="flex flex-wrap gap-5 mt-6 text-sm text-lp-muted">
              <span className="flex items-center gap-2"><Calendar size={15} /> {new Date(post.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</span>
              <span className="flex items-center gap-2"><Clock size={15} /> {post.read_time}</span>
              <span>By {post.author}</span>
            </div>
          </div>
        </div>
        {post.cover_image && (
          <div className="container-lp py-10 max-w-4xl">
            <div className="img-zoom clip-frame border border-lp-border"><img src={post.cover_image} alt={post.title} className="w-full h-[420px] object-cover" /></div>
          </div>
        )}
        <Reveal className="container-lp max-w-3xl pb-24">
          <SafeHtml className="prose-lp text-lg" html={post.content} />
          {post.tags?.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-10">{post.tags.map((t) => <span key={t} className="text-xs font-600 border border-lp-border rounded-sm px-3 py-1.5 text-lp-muted">#{t}</span>)}</div>
          )}
        </Reveal>
      </article>
    </Layout>
  );
}
